<mat-card class="payment-dialog-container pt-6 min-h-[37rem]">
  <h1 class="text-xl font-bold text-primary-main mb-1">
    {{ "wallet.registerNewPayment" | translate }}
  </h1>

  <form class="mt-8" [formGroup]="form" preventFormSubmit>
    <app-input
      labelKey="wallet.amount"
      formControlName="amount"
      onlyNumbers
      [isFloatNumber]="true"
      commasSeparateNumbers
      [formGroup]="form"
    ></app-input>
    <app-select
      labelKey="wallet.method"
      formControlName="method"
      [formGroup]="form"
      [options]="paymentMethodOptionsTR"
      selectOptionsTranslatePrefix="enums.PaymentMethodTypeEnum"
      (selectionChange)="selectionChange($event)"
    ></app-select>

    <app-date-picker
      labelKey="wallet.receiveDate"
      formControlName="date"
      [formGroup]="form"
    ></app-date-picker>

    @if (selectedPaymentMethod === paymentMethodTypeEnum.CHEQUE) {
      <div>
        <app-date-picker
          labelKey="wallet.finishChequeDate"
          formControlName="cheque_due_date"
          [formGroup]="form"
        ></app-date-picker>
      </div>
    }

    <app-textarea
      labelKey="description"
      formControlName="description"
      [formGroup]="form"
      [rows]="3"
    ></app-textarea>

    <div class="flex w-full justify-end gap-2 mt-4">
      <app-button
        variant="outlined"
        color="primary-main"
        type="button"
        size="large"
        (click)="cancel()"
      >
        {{ "close" | translate }}
      </app-button>

      <app-button
        variant="filled"
        color="primary-main"
        type="submit"
        size="large"
        (click)="submit()"
        [disabled]="!form.dirty || isLoading"
        [isLoading]="isLoading"
      >
        {{ "submit" | translate }}
      </app-button>
    </div>
  </form>
</mat-card>
